import { API_VERSION_ESYMANDANT, fetchHandler, fileUploadRequestBuilder, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postFilesByAccountId = (accountId, files) => {
    const request = fileUploadRequestBuilder(API_VERSION_ESYMANDANT + '/e.consult.' + accountId + '/files/upload', files)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}